import { Button, CircularProgress, Divider, Grid, withStyles } from '@material-ui/core';
import html2canvas from 'html2canvas';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import SpecificComponent from '../../commons/SpecificComponent';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import AnalizaCashFlow from './AnalizaCashFlow';
import AnalizaLucratorilor from './AnalizaLucratorilor';
import AnalizaProfitPierdere from './AnalizaProfitPierdere';
import AnalizaSiRaportareProiecte from './AnalizaSiRaportareProiecte';
import AnalizaStocurilor from './AnalizaStocurilor';
import AnalizaVanzarilorAditionale from './AnalizaVanzarilorAditionale';
import AnalizaVanzariSiClienti from './AnalizaVanzariSiClienti';
import FinanciarFunctions from './FinanciarFunctions';
import PlanificarePrognoza from './PlanificarePrognoza';
import RaportSolduriClienti from './RaportSolduriClienti';
import RaportSolduriFurnizori from './RaportSolduriFurnizori'
import jsPDF from 'jspdf'
import CheltuieliSiPreviziuni from './CheltuieliSiPreviziuni';
import AlertNew from '../../commons/dialogs/AlertNew';
import LocalStorage from '../../providers/LocalStorage';


export default class DiagnosticFinanciar extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            bilanturi: [],
            bilanturiRaportDesc: [],
            bilanturiRaportAsc: [],
            loading: false,
            alertView:false
        }
    }

    ws = new Ws()
    u = new Utils()
    f = new FinanciarFunctions()
    ls = new LocalStorage().GetUserData()

    componentDidMount() {
        this.access()
        this.getData()
    }

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.AccessFinanciar === 1 ? false : true })
        }


    }

    getData = async () => {


        let getBilanturi = await this.ws.customSelect('select * from fin_import_bilant_head where isnull(sters,0) != 1 order by an desc', {
            p1: 1
        })

        console.log('getBilanturi :>> ', getBilanturi);


        if (getBilanturi.Succes) {


            let bilanturi = [...getBilanturi.Content]

            let bilanturiComparatie = []



            console.log('bilanturi :>> ', bilanturi);
            if (bilanturi.length >= 2) {


                for (let i = 0, n = bilanturi.length > 3 ? 3 : bilanturi.length; i < n; i++) {

                    bilanturiComparatie.push(bilanturi[i])
                }

                let iduriB = [...new Set(bilanturi.map((b) => { return b.id }))]

                console.log('iduriB :>> ', iduriB);


                let getBilanturiRows = await this.ws.customSelect(`select * from fin_import_bilant_rows where id_head in (${iduriB.toString()})`, {
                    p1: 1
                })

                console.log('getBilanturiRows :>> ', getBilanturiRows);


                if (getBilanturiRows.Succes) {
                    let bRows = [...getBilanturiRows.Content]


                    for (let i = 0, n = bilanturiComparatie.length; i < n; i++) {

                        let filterBrows = bRows.filter(b => b.id_head === bilanturiComparatie[i].id)

                        bilanturiComparatie[i]['bilanturi_rows'] = filterBrows

                    }


                }
                console.log('bilanturiComparatie :>> ', bilanturiComparatie);

                let bilanturiComparatie2 = [...bilanturiComparatie]

                this.setState({
                    bilanturi: getBilanturi.Content,
                    bilanturiRaportDesc: bilanturiComparatie,
                    bilanturiRaportAsc: bilanturiComparatie2.sort((a, b) => {
                        if (a.an > b.an) {
                            return 1
                        } else {
                            return -1
                        }
                    })
                }, () => {

                    console.log('this.state.bilanturiRaportDesc :>> ', this.state.bilanturiRaportDesc);
                    console.log('this.state.bilanturiRaportDesc :>> ', this.state.bilanturiRaportAsc);

                })

            } else {

                console.log('else :>>bilanturi' );
                console.log('this.state.bilanturiRaportDesc :>> ', this.state.bilanturiRaportDesc);
                console.log('this.state.bilanturiRaportDesc :>> ', this.state.bilanturiRaportAsc);
                this.setState({ bilanturi: getBilanturi.Content,
                    bilanturiRaportDesc:[],
                    bilanturiRaportAsc:[] })
            }



        }

    }







    goToBilanturi = () => {
        this.props.history.push('/managementbilanturi')
    }


    printDocument() {
        const input = document.getElementById('divToPrint');

        this.setState({ loading: true }, () => {

            html2canvas((document.body)).then((canvas) => {
                let contentWidth = canvas.width
                let contentHeight = canvas.height
                let pageHeight = contentWidth / 570.28 * 841.89

                console.log('contentWidth :>> ', contentWidth);
                console.log('contentHeight :>> ', contentHeight);

                let leftHeight = contentHeight

                let position = 0

                let imgWidth = 570.28

                let imgHeight = 555.28 / contentWidth * contentHeight

                let pageData = canvas.toDataURL('image/png', 1.0)

                let pdf = new jsPDF('', 'pt', 'a4')



                if (leftHeight < pageHeight) {
                    pdf.addImage(pageData, 'JPEG', 10, 0, imgWidth, imgHeight)

                } else {
                    while (leftHeight > 0) {
                        pdf.addImage(pageData, 'JPEG', 10, position, imgWidth, imgHeight)
                        leftHeight -= pageHeight;
                        position -= 841.89

                        if (leftHeight > 0) {
                            pdf.addPage()
                        }
                    }
                }

                pdf.save('RaportGeneral.pdf')


                this.setState({ loading: false })
            })


        })




    }

    render() {
        return (
            <div>

                <CustomAppBar history={this.props.history} title='' />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                {this.state.loading &&
                    <div data-html2canvas-ignore="true" className='loading-div' >

                        <CircularProgress
                            style={{
                                width: 60,
                                height: 60,
                                color: '#25e048',
                                marginTop: '40%'
                            }}
                            value={20}

                        />
                        <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                    </div>
                }

                <Grid id='divToPrint' style={{ maxWidth: 1200, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid container>
                            <Grid item xs={7} sm={7} md={7} lg={7} xl={7}>

                                <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.financiar.diagnosticFinanciar} </h1>
                            </Grid>

                            <Grid style={{ paddingTop: 10 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                <Grid style={{ margin: '80px 0 40px 0' }} container >
                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>

                                        <span style={{ fontSize: 30 }}>{this.state.bilanturi.length}</span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left', fontSize: 12, paddingTop: 4 }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                        <Grid container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <span>{this.dictionary.financiar.bilanturi}</span>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <span>{this.dictionary.financiar.inSistem}</span>
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                </Grid>


                            </Grid>

                            <Grid data-html2canvas-ignore="true" style={{ margin: '80px 0 40px 0', paddingTop: 10 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <Button

                                    style={{ marginRight: 20 }}

                                    className={'add-button-blue'} onClick={this.goToBilanturi}  >

                                    <i style={{
                                        fontSize: 14,
                                        marginRight: 10
                                    }} className='material-icons'>person_add</i>

                                    {this.dictionary.financiar.bilanturi}
                                </Button>
                            </Grid>

                        </Grid>



                    </Grid>



                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >


                        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, }}>



                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.situatieGenerala} </h5>


                                <Divider className='pm-divider' />
                            </Grid>

                            {this.state.bilanturiRaportDesc.length === 0 &&

                                < Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, fontWeight: 400, fontSize: 14 }} >{this.dictionary.financiar.nuExistSuficienteBilanturi} </h5>


                                    <Divider className='pm-divider' />
                                </Grid>

                            }

                            {this.state.bilanturiRaportDesc.length > 0 &&

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                    <Grid style={{ marginTop: 20 }} container>

                                        <Grid style={{ textAlign: 'left' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.totalVenituri}</span>
                                            <span style={{ marginRight: 20, fontSize: 20, display: 'block', fontWeight: 600 }}>{this.u.formatNumber(this.f.getTotalVenituriBilant(this.state.bilanturiRaportDesc[0]))} Lei

                                            <i
                                                    style={{
                                                        marginLeft: 10,
                                                        verticalAlign: 'middle',
                                                        color: Math.sign(Number(this.f.diferentaTotalVenituri(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]))) === 1 ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                                    }}
                                                    className='material-icons'>{Math.sign(Number(this.f.diferentaTotalVenituri(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]))) === 1 ? 'trending_up' : 'trending_down'} </i>
                                            </span>
                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>
                                                {Math.sign(Number(this.f.diferentaTotalVenituri(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]))) === 1 ? '+' : ''} {this.f.diferentaTotalVenituri(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1])} {this.dictionary.financiar.fataDeAnulTrecut}
                                            </span>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.totalCheltuieli}</span>
                                            <span style={{ marginRight: 20, fontSize: 20, display: 'block', fontWeight: 600 }}>{this.u.formatNumber(this.f.getTotalCheltuieli(this.state.bilanturiRaportDesc[0]))} Lei
                                            <i
                                                    style={{
                                                        marginLeft: 10,
                                                        verticalAlign: 'middle',
                                                        color: Math.sign(Number(this.f.diferentaTotalVenituri(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]))) === -1 ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                                    }}
                                                    className='material-icons'>{Math.sign(Number(this.f.diferentaTotalVenituri(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]))) === 1 ? 'trending_up' : 'trending_down'} </i>
                                            </span>
                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>
                                                {Math.sign(Number(this.f.diferentaTotalCheltuieli(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]))) === 1 ? '+' : ''} {this.f.diferentaTotalCheltuieli(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1])} {this.dictionary.financiar.fataDeAnulTrecut}
                                            </span>
                                        </Grid>
                                        <Grid style={{ textAlign: 'right' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.dictionary.financiar.totalProfit}</span>
                                            <span style={{ marginRight: 20, fontSize: 18, display: 'block', fontWeight: 600 }}>{this.u.formatNumber(this.f.getTotalProfitSauPierdere(this.state.bilanturiRaportDesc[0]))} Lei
                                            <i
                                                    style={{
                                                        marginLeft: 10,
                                                        verticalAlign: 'middle',
                                                        color: Math.sign(Number(this.f.diferentaTotalVenituri(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]))) === 1 ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                                    }}
                                                    className='material-icons'>{Math.sign(Number(this.f.diferentaTotalVenituri(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]))) === 1 ? 'trending_up' : 'trending_down'} </i>
                                            </span>
                                            <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>
                                                {Math.sign(Number(this.f.diferentaTotalProfit(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]))) === 1 ? '+' : ''} {this.f.diferentaTotalProfit(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1])} {this.dictionary.financiar.fataDeAnulTrecut}
                                            </span>

                                        </Grid>

                                    </Grid>

                                    <Divider style={{ marginTop: 20 }} className='pm-divider' />

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, fontSize: 14 }} >{this.dictionary.financiar.situatie} :

                                   <span style={{ color: this.f.colorProfit(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1]) }}>{this.f.mesajProfit(this.state.bilanturiRaportDesc[0], this.state.bilanturiRaportDesc[1])}</span>
                                        </h5>
                                    </Grid>

                                </Grid>

                            }



                        </Grid>

                    </Grid>

                    {this.state.bilanturiRaportDesc.length > 0 &&

                        // console.warn('this.state.bilanturiRaportDesc CLIENT COMPONENT :>> ', this.state.bilanturiRaportDesc) &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <RaportSolduriClienti
                                bilanturiDesc={this.state.bilanturiRaportDesc}
                                bilanturiAsc={this.state.bilanturiRaportAsc}


                            />
                        </Grid>


                    }


                    {this.state.bilanturiRaportDesc.length > 0 &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <RaportSolduriFurnizori
                                bilanturiDesc={this.state.bilanturiRaportDesc}
                                bilanturiAsc={this.state.bilanturiRaportAsc}


                            />
                        </Grid>


                    }

                    {this.state.bilanturiRaportDesc.length > 0 &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <AnalizaCashFlow
                                bilanturiDesc={this.state.bilanturiRaportDesc}
                                bilanturiAsc={this.state.bilanturiRaportAsc}


                            />
                        </Grid>


                    }


                    {this.state.bilanturiRaportDesc.length > 0 &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <PlanificarePrognoza
                                bilanturiDesc={this.state.bilanturiRaportDesc}
                                bilanturiAsc={this.state.bilanturiRaportAsc}


                            />
                        </Grid>


                    }

                    {this.state.bilanturiRaportDesc.length > 0 &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <CheltuieliSiPreviziuni
                                bilanturiDesc={this.state.bilanturiRaportDesc}
                                bilanturiAsc={this.state.bilanturiRaportAsc}


                            />
                        </Grid>


                    }

                    {this.state.bilanturiRaportDesc.length > 0 &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <AnalizaProfitPierdere
                                bilanturiDesc={this.state.bilanturiRaportDesc}
                                bilanturiAsc={this.state.bilanturiRaportAsc}


                            />
                        </Grid>


                    }

                    {this.state.bilanturiRaportDesc.length > 0 &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <AnalizaVanzariSiClienti
                                bilanturiDesc={this.state.bilanturiRaportDesc}
                                bilanturiAsc={this.state.bilanturiRaportAsc}


                            />
                        </Grid>


                    }


                    {this.state.bilanturiRaportDesc.length > 0 &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <AnalizaVanzarilorAditionale
                                bilanturiDesc={this.state.bilanturiRaportDesc}
                                bilanturiAsc={this.state.bilanturiRaportAsc}


                            />
                        </Grid>


                    }

                    {this.state.bilanturiRaportDesc.length > 0 &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <AnalizaSiRaportareProiecte

                            />
                        </Grid>
                    }

                    {this.state.bilanturiRaportDesc.length > 0 &&
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <AnalizaLucratorilor

                            />
                        </Grid>
                    }


                    {this.state.bilanturiRaportDesc.length > 0 &&

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <AnalizaStocurilor
                                bilanturiDesc={this.state.bilanturiRaportDesc}
                                bilanturiAsc={this.state.bilanturiRaportAsc}


                            />
                        </Grid>


                    }


                    {this.state.bilanturiRaportDesc.length > 0 &&
                        <Grid data-html2canvas-ignore="true" style={{ marginTop: 20, textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Button
                                style={{}}

                                className={'add-button-blue'} onClick={() => { this.printDocument() }}  >
                                <i style={{
                                    fontSize: 14,
                                    marginRight: 10
                                }} className='material-icons'>description</i>

                                {this.dictionary.financiar.raportGeneral}
                            </Button>

                        </Grid>
                    }

                </Grid>


            </div >
        );
    }
}